export const BO_DASHBOARD_NEWS_UNLEASH_TOGGLE = "strapi_bo_dashboard_news"
export const ADVICES_UNLEASH_TOGGLE = "strapi_advices"
export const HOMEPAGE_HIGHLIGHTED_POSTS_UNLEASH_TOGGLE = "strapi_homepage_highlighted_posts"
export const ABOUT_UNLEASH_TOGGLE = "strapi_about"
export const CORPORATE_UNLEASH_TOGGLE = "strapi_corporate"
